import { ReactElement, useMemo } from "react";

function Table(props: {
  items: Array<any>;
  cols: Array<{
    key: string;
    col?: number;
    format?: (val: string | number) => string | ReactElement;
    className?: string;
  }>;
  titles?: { [key: string]: string };
  header?: string | ReactElement;
  rank?: boolean;
  rankCol?: number;
  classNameHeader?: string;
  startRank?: number;
  colorFirst?: boolean;
}) {
  const hasRank = useMemo(() => props.rank ?? true, [props.rank]);
  return (
    <div className="flex-fill rank-table">
      {props.header ? (
        <div className={`rank-thead ${props.classNameHeader ?? ""}`}>
          {props.header}
        </div>
      ) : null}
      <div className="rank-tbody">
        {props.titles || props.colorFirst ? (
          <div
            className={`row g-0 text-center${props.titles ? "" : " d-none"}`}
          >
            {hasRank ? (
              <div key="rank" className={`col-${props.rankCol ?? 1}`}></div>
            ) : null}
            {props.cols.map((col) => (
              <div
                key={col.key}
                className={
                  `${col.className ?? ""} ` +
                  (col.col ? `col-${col.col}` : "col")
                }
              >
                {props.titles?.[col.key]}
              </div>
            ))}
          </div>
        ) : null}
        {props.items.map((item, index) => {
          const rank = item.rank ?? index + (props.startRank ?? 1);
          return (
            <div
              key={item.id ?? rank}
              className={`rank-list row g-0 rank-${rank}`}
            >
              {hasRank ? (
                <div
                  key="rank"
                  className={`col-${
                    props.rankCol ?? 1
                  } justify-content-center d-flex align-items-center position-relative`}
                  style={{
                    minHeight: "1.75em",
                  }}
                >
                  {rank > 3 ? (
                    <div
                      className="d-flex rounded-circle align-items-center justify-content-center position-relative"
                      style={{
                        width: "1.1em",
                        height: "1.1em",
                        fontSize: "0.8em",
                        background: "#000000B2",
                      }}
                    >
                      <span>{rank}</span>
                    </div>
                  ) : (
                    <img
                      alt={"" + rank}
                      src={`/assets/rank${rank}.png?v=1`}
                      width="80%"
                      height="auto"
                      loading="eager"
                      className="position-absolute start-50 translate-middle"
                      style={{
                        top: "40%",
                        objectFit: "contain",
                        objectPosition: "center",
                        width: "1.5em",
                        height: "1.5em",
                      }}
                    />
                  )}
                </div>
              ) : null}
              {props.cols.map((col) => (
                <div
                  key={col.key}
                  className={
                    `${col.className ?? ""} ` +
                    (col.col ? `col-${col.col}` : "col")
                  }
                  style={{ fontSize: "0.9em" }}
                >
                  <span>
                    {col.format ? col.format(item[col.key]) : item[col.key]}
                  </span>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Table;
